export enum DrinksCategory {
    HOTDRINKS = 'hotDrinks',
    NOALCDRINKS = 'noAlcDrinks',
    BEER = 'beer',
    LONGDRINKS = 'longDrinks',
    COCKTAILS = 'cocktails',
    NOALCCOCKTAILS = 'noAlcCocktails',
    APERITIFS = 'aperitifs',
    VINE = 'vine',
    SHOTS = 'shots',
    BOTTLES = 'bottles'
}

export interface Drink {
    name: string;
    description?: string;
    amount?: Number;
    category: DrinksCategory;
    price: number;
}

export const drinks: Drink[] = [
    // Hot Drinks
    {
        name: "Espresso ⁶",
        category: DrinksCategory.HOTDRINKS,
        price: 2.80,
    },
    {
        name: "Kaffee ⁶",
        category: DrinksCategory.HOTDRINKS,
        price: 3.80,
    },
    {
        name: "Cappuccino ⁷ᵍ",
        category: DrinksCategory.HOTDRINKS,
        price: 4.20
    },
    {
        name: "Latte Macchiatto ⁶ᵍ",
        category: DrinksCategory.HOTDRINKS,
        price: 4.50
    },
    {
        name: "Tee",
        category: DrinksCategory.HOTDRINKS,
        price: 4.20
    },
    // Cold Drinks (Non-Alcoholic)
    {
        name: "ViO",
        description: "Still",
        amount: 0.25,
        category: DrinksCategory.NOALCDRINKS,
        price: 3.20
    },
    {
        name: "Apollinaris",
        description: "Sprudel",
        amount: 0.25,
        category: DrinksCategory.NOALCDRINKS,
        price: 3.20
    },
    {
        name: "Apfelschorle",
        amount: 0.4,
        category: DrinksCategory.NOALCDRINKS,
        price: 4.50
    },
    {
        name: "Cola ⁴⁶⁷",
        amount: 0.2,
        category: DrinksCategory.NOALCDRINKS,
        price: 3.50
    },
    {
        name: "Cola Zero ³⁴⁵⁶⁷",
        amount: 0.2,
        category: DrinksCategory.NOALCDRINKS,
        price: 3.50
    },
    {
        name: "ElephantBay Ice-Tea ²⁴⁷",
        amount: 0.33,
        category: DrinksCategory.NOALCDRINKS,
        price: 4.60
    },
    {
        name: "Fanta ²⁴⁷⁸",
        amount: 0.2,
        category: DrinksCategory.NOALCDRINKS,
        price: 3.50
    },
    {
        name: "Sprite ⁷",
        amount: 0.2,
        category: DrinksCategory.NOALCDRINKS,
        price: 3.50
    },
    {
        name: "Mezzo Mix ⁴⁷⁸",
        amount: 0.2,
        category: DrinksCategory.NOALCDRINKS,
        price: 3.50
    },
    {
        name: "Moloko ⁴⁶⁷",
        category: DrinksCategory.NOALCDRINKS,
        price: 4.50
    },
    {
        name: "Orangina ⁴⁶⁷",
        category: DrinksCategory.NOALCDRINKS,
        price: 4.50
    },
    {
        name: "Redbull ⁴⁶⁷",
        amount: 0.25,
        description: "Jegliche Geschmacksrichtungen",
        category: DrinksCategory.NOALCDRINKS,
        price: 4.50
    },
    {
        name: "Saft",
        description: "KiBa, O-Saft",
        category: DrinksCategory.NOALCDRINKS,
        price: 4.50
    },
    {
        name: "Schwarze Dose ⁴⁶⁷",
        amount: 0.25,
        category: DrinksCategory.NOALCDRINKS,
        price: 4.50
    },
    {
        name: "Schweppes Bitter Lemon ¹¹",
        amount: 0.2,
        description: "Ginger Ale, Tonic Water, Bitter Lemon",
        category: DrinksCategory.NOALCDRINKS,
        price: 3.80
    },
    // Beer
    {
        name: "Bananenweizen",
        amount: 0.5,
        category: DrinksCategory.BEER,
        price: 4.80
    },
    {
        name: "Corona",
        amount: 0.33,
        category: DrinksCategory.BEER,
        price: 4.50
    },
    {
        name: "Desperados",
        amount: 0.33,
        category: DrinksCategory.BEER,
        price: 4.50
    },
    {
        name: "Hefe",
        amount: 0.33,
        category: DrinksCategory.BEER,
        price: 4.50
    },
    {
        name: "Heinken",
        amount: 0.33,
        category: DrinksCategory.BEER,
        price: 4.20
    },
    {
        name: "Paulaner Hefeweizen",
        amount: 0.5,
        category: DrinksCategory.BEER,
        price: 4.50
    },
    {
        name: "Paulaner Kristall",
        amount: 0.5,
        category: DrinksCategory.BEER,
        price: 4.50
    },
    {
        name: "Radler",
        category: DrinksCategory.BEER,
        price: 4.80
    },
    {
        name: "Stuttgarter Pils",
        amount: 0.5,
        category: DrinksCategory.BEER,
        price: 4.50
    },
    {
        name: "Wulle",
        amount: 0.33,
        category: DrinksCategory.BEER,
        price: 4.50
    },
    // Non-Alcoholic Cocktails
    {
        name: "Coconut Kiss",
        category: DrinksCategory.NOALCCOCKTAILS,
        price: 6.80
    },
    {
        name: "Ipanema",
        category: DrinksCategory.NOALCCOCKTAILS,
        price: 8.50
    },
    {
        name: "Sex on the Beach",
        category: DrinksCategory.NOALCCOCKTAILS,
        price: 7.50
    },
    {
        name: "Surfer's Trip",
        category: DrinksCategory.NOALCCOCKTAILS,
        price: 7.50
    },
    {
        name: "Swimming Pool",
        category: DrinksCategory.NOALCCOCKTAILS,
        price: 6.80
    },
    // Alcoholic Cocktails
    {
        name: "Caipirinha",
        category: DrinksCategory.COCKTAILS,
        price: 8.90
    },
    {
        name: "Cuba Libre",
        category: DrinksCategory.COCKTAILS,
        price: 8.90
    },
    {
        name: "Dangerous",
        category: DrinksCategory.COCKTAILS,
        price: 8.90
    },
    {
        name: "Long Island Ice Tea",
        category: DrinksCategory.COCKTAILS,
        price: 8.90
    },
    {
        name: "Mojito",
        category: DrinksCategory.COCKTAILS,
        price: 8.90
    },
    {
        name: "Pina Colada",
        category: DrinksCategory.COCKTAILS,
        price: 8.50
    },
    {
        name: "Sex on the Beach",
        category: DrinksCategory.COCKTAILS,
        price: 8.50
    },
    {
        name: "Swimmingpool",
        category: DrinksCategory.COCKTAILS,
        price: 8.50
    },
    {
        name: "Tequila Sunrise",
        category: DrinksCategory.COCKTAILS,
        price: 8.50
    },
    {
        name: "Zombie",
        category: DrinksCategory.COCKTAILS,
        price: 8.90
    },
    // Long Drinks
    {
        name: "Chivas Regal On the Rocks",
        category: DrinksCategory.LONGDRINKS,
        price: 8.50
    },
    {
        name: "Gin & Tonic Water",
        category: DrinksCategory.LONGDRINKS,
        price: 7.50
    },
    {
        name: "Hennessy On the Rocks",
        category: DrinksCategory.LONGDRINKS,
        price: 8.90
    },
    {
        name: "Jacky Daniel's & Coca Cola",
        category: DrinksCategory.LONGDRINKS,
        price: 7.50
    },
    {
        name: "Vodka & Redbull",
        category: DrinksCategory.LONGDRINKS,
        price: 7.50
    },
    // Wine
    {
        name: "Rotwein",
        category: DrinksCategory.VINE,
        price: 5.50
    },
    {
        name: "Weißwein",
        category: DrinksCategory.VINE,
        price: 5.50
    },
    {
        name: "Weißwein Schorle",
        category: DrinksCategory.VINE,
        price: 6.50
    },
    // Aperitifs
    {
        name: "Hugo",
        description: "Minze, Soda, Holunder, Prosecco",
        category: DrinksCategory.APERITIFS,
        price: 6.80
    },
    {
        name: "Aperol Spritz",
        description: "Standard, Orange, Prosecco, Soda",
        category: DrinksCategory.APERITIFS,
        price: 6.80
    },
    {
        name: "Lillet",
        description: "Standard, Prosecco, Wild Berry",
        category: DrinksCategory.APERITIFS,
        price: 6.80
    },
    // Shots
    {
        name: "Jägermeister",
        category: DrinksCategory.SHOTS,
        price: 2.50
    },
    {
        name: "Vodka",
        category: DrinksCategory.SHOTS,
        price: 2.50
    },
    {
        name: "Jack Daniel`s",
        category: DrinksCategory.SHOTS,
        price: 2.50
    },
    {
        name: "Raki",
        category: DrinksCategory.SHOTS,
        price: 2.50
    },
    {
        name: "Ramazotti",
        category: DrinksCategory.SHOTS,
        price: 2.50
    },
    // Bottles
    {
        name: "Champagner Moët",
        category: DrinksCategory.BOTTLES,
        price: 90.00
    },
    {
        name: "Champagner Veuve",
        category: DrinksCategory.BOTTLES,
        price: 90.00
    },
    {
        name: "Belvedere / Grey Goose",
        category: DrinksCategory.BOTTLES,
        price: 90.00
    },
    {
        name: "Jack Daniel`s",
        category: DrinksCategory.BOTTLES,
        price: 75.00
    },
    {
        name: "Absolut Vodka",
        category: DrinksCategory.BOTTLES,
        price: 65.00
    },
]
